import Ardea1 from '../Ardea/Ardea.webp'
import Ardea2 from '../Ardea/Ardea (2).webp'
import Ardea3 from '../Ardea/Ardea (3).webp'
import Ardea4 from '../Ardea/Ardea (4).webp'
import Ardea5 from '../Ardea/Ardea (5).webp'
import Ardea6 from '../Ardea/Ardea (6).webp'
import Ardea7 from '../Ardea/Ardea (7).webp'
import Ardea8 from '../Ardea/Ardea (8).webp'
import Ardea9 from '../Ardea/Ardea (9).webp'
import Ardea10 from '../Ardea/Ardea (10).webp'
import Ardea11 from '../Ardea/Ardea (11).webp'
import Ardea12 from '../Ardea/Ardea (12).webp'

const Ardeaimages =[
Ardea1,Ardea2,Ardea3,Ardea4,Ardea5,Ardea6,Ardea7,Ardea8,Ardea9,Ardea10,Ardea11,Ardea12
]

export default Ardeaimages;